import React from "react";
import CreateAndUpdatePage from "../CreateAndUpdatePage";
function CreatePage() {
  return <CreateAndUpdatePage isUpdate={true} />;
}

export default CreatePage;